module.exports = __webpack_public_path__ + "static/img/12.c4405e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/12.png
// module id = TTOU
// module chunks = 0